goog.provide("shadow.js.shim.module$src$svg$controls$scope_svg$default");
shadow.js.shim.module$src$svg$controls$scope_svg$default = shadow.js.shim.module$src$svg$controls$scope_svg.default;
